import React from "react";
import {FormattedMessage} from "react-intl";
import ContentTile from "../../../components/ContentTile";
import "./AppDomainTile.css";
import {Link} from "react-router-dom";

type AppDomain = {
  name: string;
  description: string;
  url: string;
};

type AppDomainTileProps = {
  appDomain: AppDomain;
};

function AppDomainTile({appDomain}: AppDomainTileProps) {
  return (
    <div className="appDetails__appDomain">
      <div className="appDetails__appDomainHeader">
        <h2>
          <FormattedMessage id="appDetails.header.appDomain" />
        </h2>
      </div>
      <ContentTile
        name={appDomain.name}
        description={appDomain.description}
        clickElement={
          <Link
            className="linkButton"
            to={appDomain.url}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="general.link.label.open" />
          </Link>
        }
      />
    </div>
  );
}

export default AppDomainTile;
